import * as types from './action_types';
import * as UserActions from '../user/actions';
import UserFollower from '../../services/user_follower';
import ProfileService from '../../services/profile_service';
import TackMapper from '../utils/tack_mapper';
import DateMaster from '../utils/date_master';

export const reset = () => {
  return { type: types.PROFILE_RESET };
}

export const load = (slug, skipLoading=false) => {
  return async(dispatch) => {
    if (!skipLoading) {
      dispatch({ type: types.PROFILE_LOADING });
    }
    try {
      const profileData = await ProfileService.load(slug)
      const activeTacks = [];
      for (let activeTack of profileData.active_tacks) {
        activeTacks.push(TackMapper.map(activeTack));
      }
      const finishedTacks = [];
      for (let finishedTack of profileData.finished_tacks) {
        finishedTacks.push(TackMapper.map(finishedTack));
      }
      const profile = {
        slug: profileData.slug,
        hasActiveSubscription: profileData.has_active_subscription,
        name: profileData.name,
        points: profileData.points,
        headline: profileData.headline,
        createdAt: DateMaster.parseUTC(profileData.created_at),
        followersCount: profileData.followers_count,
        followsCount: profileData.follows_count,
        followedAt: DateMaster.parseUTC(profileData.followed_at),
        activeTacks: activeTacks,
        finishedTacks: finishedTacks
      }
      dispatch({ type: types.PROFILE_LOADED, profile });
    } catch(error) {
      dispatch({ type: types.PROFILE_ERROR, error });
    }
  }
}

export const follow = (slug) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.PROFILE_FOLLOWING });
      const followData = await UserFollower.follow(slug);
      const followedAt = DateMaster.parseUTC(followData.followed_at);
      dispatch({ type: types.PROFILE_FOLLOWED, followedAt: followedAt });
      dispatch(load(slug, true));
      dispatch(UserActions.fetchAccount());
    } catch(error) {
      dispatch({ type: types.PROFILE_ERROR, error });
    }
  }
}

export const unfollow = (slug) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.PROFILE_UNFOLLOWING });
      await UserFollower.unfollow(slug);
      dispatch({ type: types.PROFILE_UNFOLLOWED });
      dispatch(load(slug, true));
      dispatch(UserActions.fetchAccount());
    } catch(error) {
      dispatch({ type: types.PROFILE_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/profile/actions.js